var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.468,
    height: 40,
    viewBox: "0 0 32.468 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397",
    transform: "translate(491.13 -127.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M-491.063,163.96c-.022-.238-.063-.477-.063-.715q0-15.541,0-31.082a4.694,4.694,0,0,1,4.935-4.645c3.551-.014,7.1,0,10.654,0q7.746,0,15.492.006a1.565,1.565,0,0,1,.843.148,2.164,2.164,0,0,1,.515.767c.048.088.01.224.01.338q0,15.1,0,30.2v.556h-.638q-13.391,0-26.781,0a4.778,4.778,0,0,0-4.777,3.817c-.047.2-.068.415-.1.623Zm20.293-20.648a2.013,2.013,0,0,1-1.2-1.843c-.013-1.531,0-3.062-.006-4.593,0-.656-.318-1.017-.862-1-.526.012-.8.351-.8,1,0,1.531-.005,3.062,0,4.593a3.645,3.645,0,0,0,2.414,3.447.576.576,0,0,1,.458.656c-.016,2.785-.011,5.571-.006,8.356a2.13,2.13,0,0,0,.077.673.746.746,0,0,0,.833.533.745.745,0,0,0,.727-.666,3.673,3.673,0,0,0,.024-.585c0-2.785.007-5.571-.007-8.356a.513.513,0,0,1,.412-.581,3.327,3.327,0,0,0,2.394-2.875c.145-1.812.1-3.642.08-5.464a.785.785,0,0,0-1.264-.591,1.169,1.169,0,0,0-.359.788c-.034,1.53-.009,3.062-.02,4.593a1.779,1.779,0,0,1-1.233,1.823c0-.541,0-1.078,0-1.615,0-1.547.007-3.095-.005-4.642a.809.809,0,0,0-.957-.889c-.442.066-.7.423-.7,1.022-.005,1.873,0,3.746,0,5.619Zm-10.391,1.874v.464q0,4.152,0,8.3a4,4,0,0,0,.006.439.819.819,0,0,0,.77.746.827.827,0,0,0,.872-.689,2.857,2.857,0,0,0,.016-.487c0-2.817,0-5.633,0-8.45a.481.481,0,0,1,.367-.56,3.513,3.513,0,0,0,2.483-3.285,30.422,30.422,0,0,0-.008-3.221,3.627,3.627,0,0,0-3.6-3.356,3.619,3.619,0,0,0-3.74,3.305,32.482,32.482,0,0,0,0,3.463,3.193,3.193,0,0,0,1.327,2.452A13.9,13.9,0,0,0-481.161,145.186Z",
    transform: "translate(0)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    d: "M-442.03,472.094c0,1.469.039,2.885-.018,4.3a2.037,2.037,0,0,1-1.016,1.427,3.012,3.012,0,0,1-1.88.57q-12.212,0-24.424,0a3.157,3.157,0,0,1-3.213-2.4,3.09,3.09,0,0,1,1.564-3.513,3.186,3.186,0,0,1,1.387-.377q13.629-.033,27.258-.017C-442.277,472.076-442.182,472.086-442.03,472.094Z",
    transform: "translate(-16.647 -310.882)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4757",
    "data-name": "Path 4757",
    d: "M-397.61,225.458c0,.5.03,1.011-.006,1.513a2,2,0,0,1-1.991,1.833,1.965,1.965,0,0,1-2.031-1.781,26.178,26.178,0,0,1,0-3.169,1.949,1.949,0,0,1,2.1-1.8,1.979,1.979,0,0,1,1.93,1.889c.031.5.005,1.009.005,1.513Z",
    transform: "translate(-80.697 -85.303)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/plate.ec3794be295254fa0f225278e220a926.svg";
export { ForwardRef as ReactComponent };